/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @typescript-eslint/no-empty-function */

import { CommonModule } from "@angular/common";
import { Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router, RouterModule, RouterOutlet } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { SegmentOption } from "@malirang/front-share";
import { CenterIconComponent } from "apps/client/src/components/center/icon/center-icon.component";
import { injectResize } from "ngxtension/resize";
import { map } from "rxjs";
import { ContainerComponent } from "../../../components/container/container.component";
import { CenterStore } from "../../../stores/center/center.store";
import { UserStore } from "../../../stores/user.store";
import { MyPageModalContainer } from "./components/my-page-modal-container/my-page-modal-container.component";

@Component({
    selector: "app-my-page-layout",
    standalone: true,
    imports: [
        CommonModule,
        ContainerComponent,
        RouterModule,
        CenterIconComponent,
        MyPageModalContainer,
        RouterOutlet,
    ],
    templateUrl: "./my-page.layout.html",
    styleUrl: "./my-page.layout.scss",
})
export class MyPageLayout {
    readonly centerStore = inject(CenterStore);
    readonly userStore = inject(UserStore);
    readonly router = inject(Router);

    platform = Capacitor.getPlatform();

    user = this.userStore.user;
    currentCenter = this.centerStore.currentCenter;
    isMobile = toSignal(
        injectResize().pipe(map((size) => size.width < 768)) ||
            window.innerWidth < 768,
    );

    segmentOptions = computed<SegmentOption[]>(() =>
        Capacitor.isNativePlatform()
            ? [
                  { label: "소속 센터", value: "center" },
                  { label: "내정보 관리", value: "info" },
                  { label: "알림 내역", value: "notification" },
                  { label: "설정", value: "setting" },
              ]
            : [
                  { label: "소속 센터", value: "center" },
                  { label: "내정보 관리", value: "info" },
                  { label: "결제 내역", value: "payment" },
                  { label: "알림 내역", value: "notification" },
                  { label: "구매 내역", value: "purchase" },
                  { label: "설정", value: "setting" },
              ],
    );
}
